// src/components/Layout.js
import React, { useState, useEffect } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, radius, shadow, } from '../styles/theme'
import { canAccessFeature, pathToKey } from '../config/features'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const I = (d) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    {(Array.isArray(d) ? d : [d]).map((p, i) => <path key={i} d={p} />)}
  </svg>
)

const ICONS = {
  '/': I('M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z'),
  '/smartbot': I('M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z'),
  '/quiz': I(['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.4-1 .9-1 1.7', 'M12 17h.01']),
  '/smart-cart': I('M6 6h15l-1.6 8H7.5zM6 6 5 3H2M9 20h.01M18 20h.01'),
  '/smart-search': I('M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.3-4.3'),
  '/smart-cip': I(['M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M4 21a8 8 0 0 1 16 0']),
  '/smart-library': I('M5 4h14v16H7a2 2 0 0 1-2-2zM5 18a2 2 0 0 1 2-2h12'),
  '/smart-blog': I('M14 3v5h5M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM9 13h6M9 17h4'),
  '/smart-mailing': I('M4 6h16v12H4zM4 7l8 6 8-6'),
  '/smart-event': I('M5 5h14v14H5zM5 9h14M9 3v4M15 3v4'),
  '/smart-target': I(['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M12 12h.01']),
  '/smart-view': I(['M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z']),
  '/smart-video': I(['M3 5h18v14H3zM10 9l5 3-5 3z']),
  '/smart-ranking': I(['M3 20h4V10H3zM10 20h4V4h-4zM17 20h4v-8h-4z']),
  '/smart-analysis': I(['M3 3v18h18', 'M7 14l3.2-3.6 3 2.4L21 7']),
  '/smart-review': I(['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z', 'M12 7.2l1.1 2.3 2.4.3-1.8 1.7.5 2.5-2.2-1.2-2.2 1.2.5-2.5-1.8-1.7 2.4-.3z']),
  '/smart-content': I(['M5 3h14v18H5z', 'M8 8h8', 'M8 12h8', 'M8 16h5']),
  '/smart-geo': I(['M4 5h10', 'M4 10h13', 'M4 15h7', 'M15 14l3 3 4-6']),
  '/smart-sgo': I(['M3 18a9 9 0 0 1 18 0', 'M12 18l5-6', 'M12 18h.01']),
  '/smart-showcase': I(['M3 4h18v5H3z', 'M5 9v11h14V9', 'M9 13h6']),
  '/segments': I(['M12 3a9 9 0 1 0 9 9', 'M12 3v9h9a9 9 0 0 0-9-9z']),
  '/influencers': I('M12 3l2.5 5.2 5.5.8-4 3.9 1 5.6L12 16l-5 2.5 1-5.6-4-3.9 5.5-.8z'),
  '/influencer-dashboard': I('M4 20V10M10 20V4M16 20v-7M22 20H2'),
  '/products': I('M4 4h16v16H4zM4 9h16M9 9v11'),
  '/brands': I('M3 9l2-5h14l2 5M4 9h16v11H4zM9 13h6'),
  '/users': I(['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8', 'M22 21v-2a4 4 0 0 0-3-3.9']),
  '/setup': I('M4 21v-6M4 11V3M12 21v-8M12 9V3M20 21v-4M20 13V3M1 15h6M9 9h6M17 17h6'),
  '/audit-logs': I(['M8 6h11M8 12h11M8 18h11', 'M3 6h.01M3 12h.01M3 18h.01']),
  '/system-monitor': I('M22 12h-4l-3 9L9 3l-3 9H2'),
}

const NAV_MAIN = [
  { path: '/',                    label: 'Dashboard',       icon: '⊞' },
  { path: '/smart-analysis',      label: 'Smart Analysis',  icon: '📈' },
  { path: '/influencer-dashboard',label: 'Inf. Dashboard',  icon: '📊' },
  { path: '/influencers',         label: 'Influencers',     icon: '★' },
  { path: '/smart-blog',          label: 'Smart Blog',      icon: '📝' },
  { path: '/smartbot',            label: 'SmartBot',        icon: '✦' },
  { path: '/smart-cart',          label: 'Smart Cart',      icon: '🛒' },
  { path: '/smart-cip',           label: 'Smart CIP',       icon: '🧠' },
  { path: '/smart-event',         label: 'Smart Event',     icon: '📅' },
  { path: '/smart-library',       label: 'Smart Library',   icon: '📚' },
  { path: '/smart-mailing',       label: 'Smart Mailing',   icon: '✉️' },
  { path: '/quiz',                label: 'Smart Quiz',      icon: '❓' },
  { path: '/smart-ranking',       label: 'Smart Ranking',   icon: '📊' },
  { path: '/smart-review',        label: 'Smart Review',    icon: '★' },
  { path: '/smart-content',       label: 'Smart Content',   icon: '📄' },
  { path: '/smart-geo',           label: 'Smart GEO',       icon: '❖' },
  { path: '/segments',            label: 'Smart Recommendation', icon: '◎' },
  { path: '/smart-search',        label: 'Smart Search',    icon: '🔍' },
  { path: '/smart-sgo',           label: 'Smart SGO',       icon: '◷' },
  { path: '/smart-showcase',      label: 'Smart Showcase',  icon: '▦' },
  { path: '/smart-target',        label: 'Smart Target',    icon: '🎯' },
  { path: '/smart-video',         label: 'Smart Video',     icon: '🎬' },
  { path: '/smart-view',          label: 'Smart View',      icon: '👁' },
]

const NAV_DATA = [
  { path: '/products',            label: 'Products',        icon: '▦' },
  { path: '/brands',              label: 'Brands',          icon: '◈' },
  { path: '/users',               label: 'Users',           icon: '◉' },
]

const NAV_BOTTOM = [
  { path: '/setup',               label: 'Setup',           icon: '⚙' },
]

function SidebarItem({ path, label, icon, collapsed }) {
  return (
    <NavLink
      to={path}
      end={path === '/'}
      style={({ isActive }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: collapsed ? '9px 0' : '9px 12px',
        borderRadius: radius.md,
        marginBottom: '2px',
        textDecoration: 'none',
        fontSize: '13px',
        fontWeight: '500',
        color: isActive ? colors.primary : colors.sidebarText,
        background: isActive ? colors.sidebarActiveBg : 'transparent',
        justifyContent: collapsed ? 'center' : 'flex-start',
        transition: 'background 0.15s, color 0.15s',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      })}
    >
      <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center', lineHeight: 1 }}>{ICONS[path] || icon}</span>
      {!collapsed && <span>{label}</span>}
    </NavLink>
  )
}

function NavSection({ label, collapsed }) {
  if (collapsed) return <div style={{ height: '12px' }} />
  return (
    <p style={{
      fontSize: '10px',
      fontWeight: '600',
      color: colors.textMuted,
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      margin: '16px 12px 4px',
    }}>
      {label}
    </p>
  )
}

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 768)
  const [mobileOpen, setMobileOpen] = useState(false)
  const { selectedBrand, brands, setSelectedBrand, account, gercekHesap, onizleme, setOnizleme } = useBrand() || {}
  const [markaListesi, setMarkaListesi] = useState([])

  useEffect(() => {
    const onResize = () => {
      const m = window.innerWidth <= 768
      setIsMobile(m)
      if (m) setCollapsed(false)   // mobilde drawer tam genişlik
      else setMobileOpen(false)    // masaüstüne dönünce drawer'ı kapat
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const gercekSuper = gercekHesap?.role === 'super_admin'

  useEffect(() => {
    if (!gercekSuper || markaListesi.length) return
    const token = localStorage.getItem('adminToken')
    if (!token) return
    axios.get(`${API}/admin/brands`, { headers: { Authorization: token } })
      .then(r => setMarkaListesi(Array.isArray(r.data) ? r.data : (r.data?.brands || [])))
      .catch(() => {})
  }, [gercekSuper, markaListesi.length])

  const SIDEBAR_W = collapsed ? 64 : 220

  // brand_admin için markaya tanımlı özelliklere göre menüyü filtrele
  const isSuper = account?.role === 'super_admin'
  const superOnly = ['/brands', '/users']
  const mainItems = NAV_MAIN.filter(i => canAccessFeature(account, pathToKey(i.path)))
  const dataItems = NAV_DATA.filter(i => canAccessFeature(account, pathToKey(i.path)) && (!superOnly.includes(i.path) || isSuper))

  return (
    <div className="sx-shell" style={{ display: 'flex', minHeight: '100vh', background: colors.bgPage, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>

      {/* Sidebar */}
      {/* Mobil drawer karartması */}
      {isMobile && mobileOpen && (
        <div onClick={() => setMobileOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 999 }} />
      )}

      <aside className="sx-drawer" style={{
        width: isMobile ? 240 : SIDEBAR_W,
        minHeight: '100vh',
        background: colors.bgSidebar,
        borderRight: `1px solid ${colors.border}`,
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0, left: 0, bottom: 0,
        zIndex: isMobile ? 1000 : 100,
        transition: 'transform 0.25s ease, width 0.2s ease',
        transform: isMobile ? (mobileOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
        boxShadow: isMobile && mobileOpen ? '4px 0 24px rgba(0,0,0,0.2)' : 'none',
        overflow: 'hidden',
      }}>

        {/* Logo */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: collapsed ? '18px 0' : '18px 20px',
          borderBottom: `1px solid ${colors.border}`,
          justifyContent: collapsed ? 'center' : 'flex-start',
          flexShrink: 0,
        }}>
          <img src="/seux-logo.png" alt="SEUX" style={{
            height: collapsed ? '18px' : '26px', width: 'auto', display: 'block', flexShrink: 0,
          }} />
          {!collapsed && (
            <span style={{ fontSize: '17px', fontWeight: 600, color: colors.textPrimary, letterSpacing: '-0.01em' }}>
              Smart
            </span>
          )}
        </div>

        {/* Brand selector */}
        {!collapsed && brands && brands.length > 0 && (
          <div style={{ padding: '12px 16px', borderBottom: `1px solid ${colors.border}` }}>
            <select
              value={selectedBrand?.id || ''}
              onChange={e => setSelectedBrand(brands.find(b => String(b.id) === e.target.value))}
              style={{
                width: '100%',
                fontSize: '12px',
                padding: '6px 10px',
                background: colors.bgPage,
                border: `1px solid ${colors.border}`,
                borderRadius: radius.md,
                color: colors.textPrimary,
                cursor: 'pointer',
                outline: 'none',
              }}
            >
              {brands.map(b => (
                <option key={b.id} value={b.id}>{b.name}</option>
              ))}
            </select>
          </div>
        )}

        {/* Nav */}
        <nav onClick={() => { if (isMobile) setMobileOpen(false) }} style={{ flex: 1, padding: collapsed ? '8px 8px' : '8px 12px', overflowY: 'auto' }}>
          {mainItems.length > 0 && <NavSection label="Main" collapsed={collapsed} />}
          {mainItems.map(item => <SidebarItem key={item.path} {...item} collapsed={collapsed} />)}
          {dataItems.length > 0 && <NavSection label="Data" collapsed={collapsed} />}
          {dataItems.map(item => <SidebarItem key={item.path} {...item} collapsed={collapsed} />)}
          {account?.role === 'super_admin' && <NavSection label="Sistem" collapsed={collapsed} />}
          {account?.role === 'super_admin' && <SidebarItem path="/system-monitor" label="Sistem Monitörü" collapsed={collapsed} />}
          {account?.role === 'super_admin' && <SidebarItem path="/audit-logs" label="Loglar" collapsed={collapsed} />}
        </nav>

        {/* Bottom */}
        <div style={{ padding: collapsed ? '8px 8px' : '8px 12px', borderTop: `1px solid ${colors.border}` }}>
          {isSuper && NAV_BOTTOM.map(item => <SidebarItem key={item.path} {...item} collapsed={collapsed} />)}
          <button
            onClick={() => setCollapsed(c => !c)}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: collapsed ? 'center' : 'flex-start',
              gap: '6px',
              padding: '9px 12px',
              marginTop: '4px',
              fontSize: '12px',
              color: colors.textMuted,
              borderRadius: radius.md,
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: '14px' }}>{collapsed ? '→' : '←'}</span>
            {!collapsed && <span>Collapse</span>}
          </button>
        </div>
      </aside>

      {/* Main area */}
      <div className="sx-main-area" style={{ marginLeft: isMobile ? 0 : SIDEBAR_W, flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', minHeight: '100vh', transition: 'margin-left 0.2s ease' }}>

        {/* Header */}
        <header className="sx-header" style={{
          minHeight: 56,
          background: colors.bgCard,
          borderBottom: `1px solid ${colors.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: isMobile ? '0 12px' : '0 24px',
          position: 'sticky',
          top: 0,
          zIndex: 90,
          boxShadow: shadow.sm,
        }}>
          {gercekSuper && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: isMobile ? '8px' : '16px', minWidth: 0, order: isMobile ? 2 : 0 }}>
              <select
                value={onizleme ? String(onizleme.id) : ''}
                onChange={e => {
                  const id = e.target.value
                  if (!id) { setOnizleme(null); return }
                  const b = markaListesi.find(x => String(x.id) === id)
                  if (b) setOnizleme(b)
                }}
                style={{
                  fontFamily: 'inherit', fontSize: '12.5px', padding: '6px 10px',
                  borderRadius: radius.md, cursor: 'pointer',
                  border: `1px solid ${onizleme ? colors.primary : colors.border}`,
                  background: onizleme ? colors.primaryLight : colors.bgCard,
                  color: onizleme ? colors.primary : colors.textSecondary,
                  fontWeight: onizleme ? 600 : 400,
                  maxWidth: isMobile ? 168 : 220,
                  minWidth: 0,
                }}
              >
                <option value="">Marka gözüyle görüntüle…</option>
                {markaListesi.map(b => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))}
              </select>
              {onizleme && !isMobile && (
                <button onClick={() => setOnizleme(null)} style={{
                  fontFamily: 'inherit', fontSize: '12px', padding: '6px 10px',
                  borderRadius: radius.md, border: `1px solid ${colors.border}`,
                  background: 'transparent', color: colors.textSecondary, cursor: 'pointer',
                }}>Çık</button>
              )}
            </div>
          )}
          {isMobile && (
            <button onClick={() => setMobileOpen(o => !o)} aria-label="Menü" style={{
              border: `1px solid ${colors.border}`, background: colors.bgCard, borderRadius: radius.md,
              width: 40, height: 40, cursor: 'pointer', color: colors.textPrimary,
              flexShrink: 0, marginRight: '8px', order: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
          )}
          <div style={{ flex: 1, order: 3 }} />

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', order: 4, flexShrink: 0 }}>
            {selectedBrand && !isMobile && (
              <span style={{
                fontSize: '12px',
                fontWeight: '500',
                color: colors.textSecondary,
                background: colors.bgPage,
                border: `1px solid ${colors.border}`,
                borderRadius: radius.md,
                padding: '5px 10px',
              }}>
                {selectedBrand.name}
              </span>
            )}
            <div style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              padding: '5px 10px',
              border: `1px solid ${colors.border}`,
              borderRadius: radius.md,
              background: colors.bgCard,
            }}>
              <div style={{
                width: 26, height: 26,
                borderRadius: '50%',
                background: colors.primary,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '11px', fontWeight: '600', color: '#fff',
              }}>A</div>
              <span className="sx-hide-sm" style={{ fontSize: '13px', fontWeight: '500', color: colors.textPrimary }}>Admin</span>
              <button
                onClick={async () => {
                  const t = localStorage.getItem('adminToken')
                  if (t) {
                    try { await axios.post(`${API}/admin/logout`, {}, { headers: { Authorization: t }, timeout: 5000 }) } catch (e) {}
                  }
                  localStorage.removeItem('adminToken')
                  localStorage.removeItem('adminAccount')
                  localStorage.removeItem('selectedBrand')
                  window.location.href = '/login'
                }}
                style={{
                  marginLeft: '4px',
                  padding: '3px 8px',
                  fontSize: '11px',
                  borderRadius: radius.sm,
                  border: `1px solid ${colors.border}`,
                  background: 'transparent',
                  color: colors.textMuted,
                  cursor: 'pointer',
                }}
              >Çıkış</button>
            </div>
          </div>
        </header>

        {onizleme && (
          <div style={{
            background: colors.primaryLight,
            borderBottom: `1px solid ${colors.primary}`,
            color: colors.primaryDark,
            fontSize: '12.5px',
            padding: isMobile ? '9px 12px' : '9px 24px',
            display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap',
          }}>
            <strong style={{ fontWeight: 600 }}>Önizleme:</strong>
            <span>{onizleme.name} markası kullanıcısının gördüğü menü gösteriliyor.</span>
            <span style={{ color: colors.textMuted }}>
              Yalnızca arayüz simülasyonudur; işlem yetkileriniz değişmez.
            </span>
            <button onClick={() => setOnizleme(null)} style={{
              marginLeft: 'auto', fontFamily: 'inherit', fontSize: '12px',
              padding: '4px 10px', borderRadius: radius.sm,
              border: `1px solid ${colors.primary}`, background: colors.bgCard,
              color: colors.primary, cursor: 'pointer', fontWeight: 500,
            }}>Önizlemeden çık</button>
          </div>
        )}

        {/* Page content */}
        <main className="sx-main" style={{ flex: 1, minWidth: 0, padding: '28px', maxWidth: 1400 }}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}